import React from "react";
import PropTypes from "prop-types";
import R from "ramda";
import moment from "moment";
import styles from "components/settings/subscription-settings.scss";
import { planDetailsType } from "custom-prop-types";
import { Plans } from "components/settings/plans";
import { Button } from "components/common/button";
import { CancelSubscriptionModal } from "components/settings/cancel-subscription-modal";
import { UpgradeDowngradeModal } from "components/settings/upgrade-downgrade-modal";

export const SubscriptionSettings = ({
  accountId,
  cancelDate,
  isCancelSubscriptionVisible,
  isChangePlanLoading,
  isUpgradeDowngradeVisible,
  onHideCancelSubscription,
  onHideUpgradeDowngrade,
  onShowCancelSubscription,
  onShowUpgradeDowngrade,
  onSetPlanDisplay,
  onUpdatePlan,
  pendingPlan,
  plan,
  plans,
  planDetails,
  planDisplay
}) => {
  const { monthlyPlans, annualPlans } = splitAndOrderPlans(plans);
  return (
    <div>
      <div className={ styles.toggle }>
        <span className={ toggleStyle("monthly", planDisplay) } onClick={ () => onSetPlanDisplay("monthly") }>
          Monthly Pricing
        </span>
      </div>
      { renderPendingPlan(pendingPlan, cancelDate) }
      <div className={ styles["plan-container"] }>
        <Plans
          accountId={ accountId }
          annualPlans={ annualPlans }
          isChangePlanLoading={ isChangePlanLoading }
          monthlyPlans={ monthlyPlans }
          onShowUpgradeDowngrade={ onShowUpgradeDowngrade }
          onUpdatePlan={ onUpdatePlan }
          planDetails={ planDetails }
          planDisplay={ planDisplay }
        />
      </div>
      { renderCancelSubscription(onShowCancelSubscription, planDetails, cancelDate) }

      <CancelSubscriptionModal
        accountId={ accountId }
        isCancelSubscriptionVisible={ isCancelSubscriptionVisible }
        isChangePlanLoading={ isChangePlanLoading }
        onHideCancelSubscription={ onHideCancelSubscription }
        onUpdatePlan={ onUpdatePlan }
      />

      <UpgradeDowngradeModal
        accountId={ accountId }
        isChangePlanLoading={ isChangePlanLoading }
        isUpgradeDowngradeVisible={ isUpgradeDowngradeVisible }
        onHideUpgradeDowngrade={ onHideUpgradeDowngrade }
        onUpdatePlan={ onUpdatePlan }
        plan={ plan }
      />
    </div>
  );
};

SubscriptionSettings.defaultProps = {
  cancelDate: null,
  pendingPlan: null,
  plan: null
};

SubscriptionSettings.propTypes = {
  accountId: PropTypes.string.isRequired,
  cancelDate: PropTypes.string,
  isCancelSubscriptionVisible: PropTypes.bool.isRequired,
  isChangePlanLoading: PropTypes.bool.isRequired,
  isUpgradeDowngradeVisible: PropTypes.bool.isRequired,
  onHideCancelSubscription: PropTypes.func.isRequired,
  onHideUpgradeDowngrade: PropTypes.func.isRequired,
  onSetPlanDisplay: PropTypes.func.isRequired,
  onShowCancelSubscription: PropTypes.func.isRequired,
  onShowUpgradeDowngrade: PropTypes.func.isRequired,
  onUpdatePlan: PropTypes.func.isRequired,
  pendingPlan: planDetailsType,
  plan: planDetailsType,
  planDetails: planDetailsType.isRequired,
  planDisplay: PropTypes.string.isRequired,
  plans: PropTypes.arrayOf(planDetailsType).isRequired
};

const splitAndOrderPlans = (plans) => {
  const monthly = plans.filter(plan => plan.subscriptionType === "MONTHLY");
  const annual = R.difference(plans, monthly);
  const sortByPlanSize = R.sortBy(R.prop("documentLimitPerMonth"));
  const monthlyPlans = R.drop(1, sortByPlanSize(monthly));
  const annualPlans = sortByPlanSize(annual);
  return { monthlyPlans, annualPlans };
};

const toggleStyle = (schedule, planDisplay) => {
  if (schedule === planDisplay) {
    return `${styles["toggle-button--active"]}`;
  }
  return `${styles["toggle-button"]}`;
};

const renderPendingPlan = (pendingPlan, cancelDate) => {
  if (cancelDate !== null) {
    return (
      <div className={ styles.cancel }>
        <h3>
          <span>Your subscription plan will change to the DIY plan on </span>
          <span>{ moment(cancelDate).format("DD/MM/YY") }</span>
        </h3>
      </div>
    );
  }

  if (pendingPlan === null) {
    return null;
  }

  return (
    <div className={ styles.pending }>
      <h3>
        <span>Your subscription plan will change to the { pendingPlan.planType } </span>
        <span>{ pendingPlan.subscriptionType.toLowerCase() } plan on </span>
        <span>{ moment(pendingPlan.periodStart).format("DD/MM/YY") }</span>
      </h3>
    </div>
  );
};

const renderCancelSubscription = (onShowCancelSubscription, planDetails, cancelDate) => {
  if (cancelDate !== null || planDetails === "DIY") {
    return null;
  }
  return (
    <div className={ styles.diy }>
      <Button danger onClick={ onShowCancelSubscription }>Cancel subscription</Button>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/js/components/settings/subscription-settings.jsx